import React, { useCallback, useEffect, useRef, useState } from 'react';
import Modal from './Modal';
import ReactCrop,{
    centerCrop,
    makeAspectCrop,
    Crop,
    PixelCrop,
    convertToPixelCrop,
} from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { canvasPreview } from './CanvasPreview.js';
import { useDebounceEffect } from './useDeBouneEffect.js';


  

function ImageUpload({
    aspectRatio,
    onUpload,
    ...props
}) {

    const [imageUpload, setImageUpload] = useState();
    const imageRef = useRef();
    const previewCanvasRef = useRef();
    const [crop, setCrop] = useState({ unit: '%', width: 30, aspect: aspectRatio });
    const [completedCrop, setCompletedCrop] = useState();
    const [uploadedImage , setUploadedImage ] = useState(null)
    const imgRef = useRef(null)
    const [aspect, setAspect] = useState(16 / 9)
    const [scale, setScale] = useState(1)
    const [rotate, setRotate] = useState(0)
  
    const handleImageLoad = useCallback((image) => {

       // console.log(image)
        imageRef.current = image;
    }, [])

   
    function centerAspectCrop(
      mediaWidth,
      mediaHeight,
      aspect,
    ) {
      return centerCrop(
        makeAspectCrop(
          {
            unit: '%',
            width: 90,
          },
          aspect,
          mediaWidth,
          mediaHeight,
        ),
        mediaWidth,
        mediaHeight,
      )
    }
  

  useDebounceEffect(
    async () => {

      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate,
        )
      }
    },
    100,
    [completedCrop, scale, rotate],
  )



    function generateFile(canvas, crop) {
        if (!crop || !canvas) {
            return;
        }
    
        canvas.toBlob(
            (blob) => onUpload(blob),
            'image/png',
            1
        );
    }

    function handleFileSelect(event) {
        if (event.target.files && event.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () => setImageUpload(reader.result));
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    function handleFileUpload() {
    //  console.log(completedCrop)
        generateFile(previewCanvasRef.current, completedCrop);
    }


    function onImageLoad(e) {
        if (aspect) {
          const { width, height } = e.currentTarget


          const newCrop = centerAspectCrop(width, height, aspect);

          setCrop(centerAspectCrop(width, height, aspect))

                  // Then manually set the completed crop and trigger canvasPreview
          const pixelCrop = convertToPixelCrop(newCrop, width, height);

          setCompletedCrop(pixelCrop);

        }

      

    }


    return (
        <Modal id={props.id} title='Upload Image' confirmText='Upload' closeText='Close' onConfirm={handleFileUpload}>
                <p className='lead'>1. Choose a file.</p>
                <div>
                    <input className='form-control mb-3' type="file" accept="image/*" onChange={handleFileSelect} />
                </div>
                <p className='lead'>2. Click and drag to crop.</p>
                <p><small>The crop will be locked to the proper aspect ratio for the app.</small></p>

                {
                    imageUpload && (

                        <ReactCrop
                            src={imageUpload}
                            crop={crop}
                            onChange={setCrop}
                            onComplete={(c) => setCompletedCrop(c)}
                            >
        
                            <img
                                alt='Crop me'
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    display: 'block',
                                    margin: '0 auto'
                                }}
                                src={imageUpload}
                                onLoad={onImageLoad}
                                ref={imgRef}

                            />
                        </ReactCrop>
                    )
                }


                {!!completedCrop && (

                <canvas
             className='d-none'
                ref={previewCanvasRef}
                style={{
                  // border: '1px solid black',
                  objectFit: 'contain',
                  width: completedCrop.width,
                  height: completedCrop.height,
                }}
                />

                )}

        </Modal>
    );
}

export default ImageUpload;